import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCreatedTechnicianVisitBlockData from '../../../Models/Content/SelfCreatedTechnicianVisitBlockData';
import SelfCreatedTechnicianVisit from './SelfCreatedTechnicianVisit';
export default class SelfCreatedTechnicianVisitBlock extends EpiComponent<SelfCreatedTechnicianVisitBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (  
          <SelfCreatedTechnicianVisit iContent={this.props.data}/>
      )
    }
}